import {
    Dialog,
    DialogContent
} from '@/components/ui/dialog'   
import { TableData } from '@/components/Table/type'
import { createColumnHelper } from '@tanstack/react-table'
import Table from '@/components/Table'
import { useEmployeeQuery } from '@/queries/useEmployeeQuery'
import { useEffect, useMemo } from 'react' 
import DefaultColumn from '@/components/Table/components/DefaultColumn' 
import { Employee } from '@/types/Employee'
import { useTable } from '@/hooks/useTable'  
import DadosMestreHeader from '../../../components/DadosMestreHeader' 
import DadosMestreHeaderActions from '../../../components/DadosMestreHeaderActions'  

export type EmployeeTable = TableData<Employee>

const columnHelper = createColumnHelper<Employee>()

interface EmployeeDialogProps {
    SK_REVENDA: number
    isOpen: boolean
    onClose: () => void
}

const EmployeeDialog = ({ SK_REVENDA, isOpen, onClose }: EmployeeDialogProps) => {

    const {
        table,
        tableState,
        selectedRows,  
        onClickMultiDelete, 
        setTable,  
    } = useTable<Employee>('') 
 


    const { data, isFetching, isPending, refetch } = useEmployeeQuery(SK_REVENDA, true)
    
    useEffect(() => {   
        refetch()
    }, [SK_REVENDA]);

    const memoData = useMemo(() => data || [], [data])
    const memoColumns = useMemo(
        () => [ 
            columnHelper.accessor('NK_FUNCIONARIO', {
                id: 'NK_FUNCIONARIO',
                header: 'Código',
                size: 100,
            }), 
            columnHelper.accessor('NM_FUNCIONARIO', {
                id: 'NM_FUNCIONARIO',
                header: 'Funcionário',
                size: 440,
            }), 
            columnHelper.accessor('DD_TIPO_VENDEDOR', {
                id: 'DD_TIPO_VENDEDOR',
                header: 'Status',
                size: 150,
            }),  
            columnHelper.accessor('DD_CARGO', {
                id: 'DD_CARGO',
                header: 'Cargo',
                size: 150,
            }),  
        ],
        []
    )

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className='max-w-[50vw] h-3/4 overflow-auto'> 
                <div className="w-full h-full p-4 overflow-hidden">
                    <Table<EmployeeTable>
                        data={memoData}
                        columns={memoColumns}
                        getRowId={(row) => row.SK_FUNCIONARIO.toString()}
                        isLoading={isPending}
                        isFetching={isFetching}
                        getTableInstance={(table) => setTable(table)}   
                        tableState={tableState}  
                        tableHeader={
                            <DadosMestreHeader
                                title={`Funcionários`}
                                onDelete={onClickMultiDelete}
                                selectedRows={
                                    table
                                        ?.getFilteredRowModel()
                                        .flatRows.filter((row) => selectedRows[row.id])
                                        .length
                                }
                            />
                        }
                        tableActions={
                            <DadosMestreHeaderActions 
                                onRefech={refetch} 
                            />
                        }  
                        defaultColumn={{
                            cell: ({ getValue }) => (
                                <DefaultColumn>{getValue() as string}</DefaultColumn>
                            ),
                        }}
                    /> 
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default EmployeeDialog
